export const ADD_MAP_TO_STATE = 'ADD_MAP_TO_STATE'
export const UPDATE_MAP_LOCATION = 'UPDATE_MAP_LOCATION'
export const UPDATE_MAP_ZOOM = 'UPDATE_MAP_ZOOM'
export const ZOOM_TO_ALL_DEVICES = 'ZOOM_TO_ALL_DEVICES'
export const ZOOM_TO_SINGLE_CAMERA = 'ZOOM_TO_SINGLE_CAMERA'
export const ZOOM_TO_NETWORK_CLOSET = 'ZOOM_TO_NETWORK_CLOSET'
export const ZOOM_TO_WIRED_DEVICE = 'ZOOM_TO_WIRED_DEVICE'
export const ZOOM_TO_DOOR_CONTROLLER = 'ZOOM_TO_DOOR_CONTROLLER'
export const ADD_MAP_COMPONENT_REFERENCES = 'ADD_MAP_COMPONENT_REFERENCES'
export const UPDATE_MAP_TYPE = 'UPDATE_MAP_TYPE'
export const THROTTLE_UPDATE_MAP_LOCATION = 'THROTTLE_UPDATE_MAP_LOCATION'
export const GET_STREETVIEW = 'GET_STREETVIEW'



// WEBPACK FOOTER //
// ./src/actions/mapTypes.js